import Icon from './icons.jsx'

/**
 * ConnectionManageModal — "Gerenciar" de uma conexão (#355): tudo o que a conexão permite, num pop-up só,
 * igual ao WhatsApp. Reconectar, vincular contas a clientes, ajustes do produto e excluir.
 *
 * Só desenha: as ações vêm prontas de `lib/connectionManage.js` e quem abre o modal liga cada `id`
 * ao fluxo que já existe (`onAction(id)`), então a regra de negócio continua nas rotas e modais de origem.
 */

function ActionCard({ action, busy, onAction }) {
  const { id, icon, title, status, desc, label, danger, disabled, hint } = action
  return (
    <div className="int-card" style={{ boxShadow: 'none', marginBottom: 12 }}>
      <div className="int-card-head">
        <div className="int-card-icon"><Icon n={icon} s={18} /></div>
        <div style={{ minWidth: 0 }}>
          <div className="int-card-title">{title}</div>
          {status && <div className="int-card-sub">{status}</div>}
        </div>
      </div>
      <div className="int-card-desc">{desc}</div>
      {hint && <div className="int-card-sub" style={{ color: '#b45309' }}>{hint}</div>}
      {label && (
        <div className="int-card-foot">
          <button
            className="btn btn-outline btn-sm"
            style={danger ? { color: 'var(--red)', borderColor: 'var(--red)' } : undefined}
            onClick={() => onAction(id)}
            disabled={disabled || busy}
          >
            {label}
          </button>
        </div>
      )}
    </div>
  )
}

export default function ConnectionManageModal({ open, onClose, title, subtitle, statusLabel, tone, served = [], actions = [], busy, onAction }) {
  if (!open) return null
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal conn-manage-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={`Gerenciar ${title}`}>
        <div className="modal-header">
          <h3 className="modal-title">Gerenciar {title}</h3>
          {subtitle && <div className="int-card-sub">{subtitle}</div>}
          {statusLabel && (
            <span className={`int-status int-status-${tone || 'neutral'}`} style={{ marginTop: 6 }}>
              <span className={`dot dot-${tone === 'neutral' || !tone ? 'gray' : tone}`} />
              {statusLabel}
            </span>
          )}
        </div>
        <div className="modal-body">
          {served.length > 0 && (
            <div className="int-card" style={{ boxShadow: 'none', marginBottom: 12 }}>
              <div className="int-card-title">Clientes atendidos por esta conexão</div>
              <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
                {served.map((s) => <li key={s.id} className="int-card-desc">{s.name}: {s.label}</li>)}
              </ul>
            </div>
          )}
          {actions.map((a) => <ActionCard key={a.id} action={a} busy={busy} onAction={onAction} />)}
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  )
}
